import { Component, OnInit } from '@angular/core';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html'
})
export class FaqComponent implements OnInit {

  public perguntas: any = undefined;

  constructor(public mainService: MainService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.mainService.http.pathRest().get('perguntas/frequentes/', true)
      .subscribe(
      sucesso => {
        this.perguntas = sucesso.json();
        for (let i = 0; i < this.perguntas.length; i++) {
          this.perguntas[i].isExpandir = false;
          this.perguntas[i].id = i + 1;
        }
      });
  }

  public expandir(id) {
     try {
      if (!this.perguntas[id - 1].isExpandir) {
        for (let i = 0; i < this.perguntas.length; i++) {
          this.perguntas[i].isExpandir = false;
        }
        this.perguntas[id - 1].isExpandir = true;
      } else if (this.perguntas[id - 1].isExpandir) {
        this.perguntas[id - 1].isExpandir = false;
      }
    } catch (error) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/menu-superior/faq/faq.component.ts